import useBoardContext from './useBoardContext'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import createBoardPermissionSelector from './createBoardPermissionSelector'

const useBoardPermission = () => {
  const { id } = useBoardContext()

  const selector = useMemo(() => createBoardPermissionSelector(id), [id])

  return useSelector(selector)
}

export default useBoardPermission
